import React, { useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Form, Input, Upload, message, Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';

const AdminCreateManager = () => {
  const [fileList, setFileList] = useState([]);
  const [form] = Form.useForm();

  const normFile = (e) => (Array.isArray(e) ? e : e?.fileList);
  const apiUrl = process.env.REACT_APP_API_URL;

  const handleFileChange = ({ fileList }) => setFileList(fileList);

  const generateText = () => {
    const name = form.getFieldValue('name');
    const department = form.getFieldValue('department');

    if (!name || !department) {
      message.warning('Lütfen önce İsim/Soyisim ve Makam alanlarını doldurun!');
      return;
    }

    const text1 = `${name}, ${department} olarak lojman yönetiminde görev yapmaktadır. Görev alanındaki süreçleri titizlikle takip ederek işleyişin düzenli ve verimli bir şekilde ilerlemesini sağlamaktadır. Ekip çalışmasına verdiği önem ve sorumluluk bilinciyle, karşılaşılan sorunların hızlı ve etkili bir şekilde çözülmesine katkıda bulunur. Ayrıca, iş süreçlerini geliştirerek daha sürdürülebilir ve verimli bir çalışma ortamı oluşturmayı hedeflemektedir.`;

    const text2 = `Çalışmalarında iletişimi ön planda tutarak ekip içi koordinasyonu güçlendiren ${name}, görev alanındaki gelişmeleri yakından takip ederek sürekli iyileştirme anlayışıyla hareket etmektedir. Verimliliği artırmak ve iş süreçlerini optimize etmek adına yenilikçi yaklaşımlar benimseyerek, ${department} alanında daha etkili ve düzenli bir sistem oluşturulmasına katkı sağlamaktadır.`;

    form.setFieldsValue({ text1, text2 });
  };

  const handleSubmit = async (values) => {
    const { name, department, text1, text2, boardType } = values;
    const formData = new FormData();

    formData.append('name', name);
    formData.append('department', department);
    formData.append('text1', text1);
    formData.append('text2', text2);
    formData.append('boardType', boardType);

    if (fileList.length > 0) {
      formData.append('img', fileList[0].originFileObj);
    }

    try {
      const response = await fetch(`${apiUrl}/api/manager`, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        message.success('Yönetici başarıyla oluşturuldu');
        form.resetFields();
        setFileList([]);
      } else {
        message.error('Bir hata oluştu');
      }
    } catch (error) {
      console.error('Error:', error);
      message.error('Bir hata oluştu');
    }
  };

  return (
    <Form
      form={form}
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 14 }}
      layout="horizontal"
      onFinish={handleSubmit}
      style={{ maxWidth: 600, margin: '0 auto' }}
    >
      <Form.Item label="İsim/Soyisim" name="name" rules={[{ required: true, message: 'İsim/Soyisim alanı boş bırakılamaz!' }]}> 
        <Input placeholder="Örnek: Alperen Ilgaz" />
      </Form.Item>

      <Form.Item label="Makam" name="department" rules={[{ required: true, message: 'Makam alanı boş bırakılamaz!' }]}> 
        <Input placeholder="Örnek: İdari Müdür" />
      </Form.Item>

      <Form.Item label="Hakkında 1" name="text1" 
      rules={[
        { required: true, message: 'Hakkında alanı boş bırakılamaz!' },
        {min:300,message:"Hakkında 1 alanı en az 300 kelime içermelidir!"},
        {max:500,message:"Hakkında 1 alanı en fazla 500 kelime içermelidir!"}
        ]}> 
        <TextArea 
        min={300}
        placeholder="Otomatik oluşturulacak veya elle yazabilirsiniz" 
        rows={6}
        />
      </Form.Item>

      <Form.Item label="Hakkında 2" name="text2" 
      rules={[
        { required: true, message: 'Hakkında alanı boş bırakılamaz!' },
        {min:300,message:"Hakkında 2 alanı en az 300 kelime içermelidir!"},
        {max:500,message:"Hakkında 2 alanı en fazla 500 kelime içermelidir!"}

        ]}> 
        <TextArea 
        min={300}
        rows={6}
        placeholder="Otomatik oluşturulacak veya elle yazabilirsiniz" />
      </Form.Item>

      <Form.Item wrapperCol={{ offset: 4, span: 14 }}>
        <Button type="dashed" onClick={generateText}>
          Hazır Metin Oluştur
        </Button>
      </Form.Item>

      <Form.Item label="Kurul Türü" name="boardType" rules={[{ required: true, message: 'Kurul tipi seçme alanı boş bırakılamaz!' }]}> 
        <Select placeholder="Bir Kurul Türü Seçin">
          <Select.Option value="management">Yönetim Kurulu</Select.Option>
          <Select.Option value="audit">Denetim Kurulu</Select.Option>
          <Select.Option value="unit">Birim Sorumlusu</Select.Option>
        </Select>
      </Form.Item>

      <Form.Item getValueFromEvent={normFile} label="Upload" valuePropName="fileList" name="img">
        <Upload action="/upload.do" listType="picture-card" fileList={fileList} onChange={handleFileChange} beforeUpload={() => false}>
          <button style={{ border: 0, background: 'none' }} type="button">
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
          </button>
        </Upload>
      </Form.Item>

      <Form.Item wrapperCol={{ offset: 4, span: 14 }}>
        <Button type="primary" htmlType="submit">
          Yönetici Oluştur
        </Button>
      </Form.Item>
    </Form>
  );
};

export default AdminCreateManager;